import React from 'react';
import { Flex, Image, useColorModeValue, Text } from '@chakra-ui/react';
import { HSeparator } from 'components/separator/Separator';
import AshokStambh from '../../../assets/img/ashok-stambh.png';

export function SidebarBrand() {
  const logoColor = useColorModeValue('navy.700', 'white');
  const brandBg = useColorModeValue('rgba(255, 255, 255, 0.8)', 'rgba(30, 41, 59, 0.8)');
  const borderColor = useColorModeValue('rgba(0, 0, 0, 0.1)', 'rgba(255, 255, 255, 0.1)');

  return (
    <Flex 
      align="center" 
      direction="column" 
      mb="20px"
      p="4"
      borderRadius="xl"
      bg={brandBg}
      border="1px solid"
      borderColor={borderColor}
      backdropFilter="blur(10px)"
      position="relative"
    >
      {/* Ashok Stambh Emblem - Static Display */}
      <Flex
        align="center"
        justify="center"
        w="80px"
        h="80px"
        borderRadius="full"
        bg="linear-gradient(135deg, white 0%, white 100%)"
        mb="3"
        border="2px solid white"
        boxShadow="0 4px 12px rgba(30, 64, 175, 0.3)"
        overflow="hidden"
      >
        <Image
          src={AshokStambh}
          alt="Ashok Stambh - National Emblem of India"
          width="100%"
          height="100%"
          objectFit="contain"
          p="8px"
          filter={useColorModeValue("none", "brightness(1.1)")}
        />
      </Flex>
      
      <Text
        as="h1"
        fontSize="md"
        fontWeight="bold"
        color={useColorModeValue("gray.800", "white")}
        textAlign="center"
        mb="1"
        lineHeight="shorter"
      >
        Yavatmal District Dashboard
      </Text>
      
      <Text
        fontSize="xs"
        color={useColorModeValue("gray.600", "gray.300")}
        textAlign="center"
        letterSpacing="wide"
        mb="2"
      >
        Government Portal
      </Text>

      <HSeparator 
        mb="3" 
        mt="3"
        borderColor={useColorModeValue("gray.200", "gray.700")}
      />
      
      <Text
        fontSize="10px"
        color={useColorModeValue("blue.600", "blue.300")}
        fontWeight="semibold"
        letterSpacing="wider"
        textTransform="uppercase"
      >
        Secure Admin Panel
      </Text>
    </Flex>
  );
}

export default SidebarBrand;